import $ from 'jquery'

$(document).ready(function () {
  // Countries
  $('select.countries').on('change', function () {
    const value = $('option:selected', this).val()
    composeUrl('country', value)
  })
})

function composeUrl (key, value) {
  const url = new URL(document.location.href)

  // Remove element if is already present and values is empty
  if (url.searchParams.has(key) && value === '') {
    url.searchParams.delete(key)
  } else {
    url.searchParams.set(key, value)
  }

  // Redirect
  document.location = url.href
}
